export default "__VITE_ASSET__ClzAYUbn__"